/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2023, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { isAws, isWxoEnabled } from './config';
import * as crnUtil from './crn';

/**
 *
 * This method maps instance ID to account ID when using get accounts API call
 * in watsonx Orchestrate nd returns the accountId for other environments
 *
 * TODO: This is a work-around because subscriptions API in MCSP won't be available till Jan 24
 * So we are passing in instance id and mapping subscription info available in GET instance/ calls
 *
 * @param {string} crn
 * @return {accountId} string
 */
export const getAccountIdByEnvironment = (crn: string): string => {
  const { scope, service_instance } = crnUtil.parse(crn);
  return isWxoEnabled && isAws ? service_instance : scope?.account;
};
